import { makeDeleteRequest } from 'owa-ows-gateway';
import { isSuccessStatusCode } from 'owa-http-status-codes';
import { format } from 'owa-strings';

const deleteAliasUrl: string = 'ows/api/beta/PremiumUser/secondaryuseralias?emailAddress={0}';

export async function deleteSecondaryUserEmail(email: string): Promise<boolean> {
    let response = await makeDeleteRequest(
        format(deleteAliasUrl, email),
        undefined,
        undefined,
        true
    );

    if (isSuccessStatusCode(response.status)) {
        return true;
    }

    return undefined;
}
